module.exports = __webpack_public_path__ + "static/media/boy-9.33f23cd6.svg";